module.exports = {
  "id": "033dbed8-b5b6-4204-9236-1412d5da15a9",
  "gtmIds": [
    "GTM-52BC25"
  ],
  "startTracking": "since_launch",
  "hasInAppVersion": false,
  "group": "skibig3",
  "language": "en-US",
  "defaultDateFormat": "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL",
  "defaultNumberFormat": null,
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "en-US"
  ],
  "website": "https://bookingskibig3-prod.spotliowebsites.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}